import triggerAnalyticsEvent, { triggerEvent, resolveClientDependency } from './analytics';
import forEach from 'lodash/forEach';

function getAccordionItemTitle(item) {
	const button = $(item).find('.Accordion-item-button');
	return button.find('.Accordion-item-title').text().trim();
}

const filterExpand = payload => {
	const title = getAccordionItemTitle(payload.item);
	if ($(payload.item).hasClass('Accordion-item--collapsed')) {
		triggerEvent('action', 'filter expand', title);
	}
};

const filterOpen = payload => {
	triggerEvent('action', 'filter open');
};

const filterApply = payload => {
	setUTagDataFilters({ filters: payload.filters });
	triggerEvent('action', 'filter apply');
};

const gridScroll = payload => {
	triggerEvent('scroll', 'grid scroll');
};

export function attachAnalyticsEvents(payload) {
	const { parent } = payload;

	//Set up Expand Filters
	const items = $(parent).find('.Accordion').children('.Accordion-item');
	forEach(items, item => {
		$(item)
			.find('.Accordion-item-button')
			.on('touchstart', function () {
				triggerAnalyticsEvent('cardgrid.filterExpand', {
					element: parent,
					item,
				});
			});
	});
}

export function setUTagDataFilters(payload) {
	const { filters, resolveDependency } = payload;
	let filtersArray = [];
	forEach(filters, filter => {
		filtersArray = filtersArray.concat(filter);
	});
	window.utag_data['page_filters_array'] = filtersArray;
	if (resolveDependency) {
		resolveClientDependency();
	}
}

export default {
	filterExpand,
	filterOpen,
	filterApply,
	gridScroll,
};
